import { AristoByteUI } from "./AristoByteUI";
import { ArrowRight } from "./ArrowRight";
import { BashCursor } from "./BashCursor";
import { Bun } from "./Bun";
import { Code } from "./Code";
import { Comment } from "./Comment";
import { Components } from "./Components";
import { Copy } from "./Copy";
import { Disabled } from "./Disabled";
import { Dot } from "./Dot";
import { Error } from "./Error";
import { Eye } from "./Eye";
import { GalleryVertical } from "./GalleryVertical";
import { GalleryVerticalEnd } from "./GalleryVerticalEnd";
import { Github } from "./Github";
import { GradientSquare } from "./GradientSquare";
import { Heart } from "./Heart";
import { Info } from "./Info";
import { Link } from "./Link";
import { Logo } from "./Logo";
import { Npm } from "./Npm";
import { OpenedBook } from "./OpenedBook";
import { Package } from "./Package";
import { Palette } from "./Palette";
import { PaperCode } from "./PaperCode";
import { Play } from "./Play";
import { Pnpm } from "./Pnpm";
import { Resize } from "./Resize";
import { Share } from "./Share";
import { Stars } from "./Stars";
import { Star } from "./Star";
import { Storybook } from "./Storybook";
import { Success } from "./Success";
import { User } from "./User";
import { UserGroup } from "./UserGroup";
import { Warning } from "./Warning";
import { Yarn } from "./Yarn";
import { LinkedIn } from "./LinkedIn";
import { Instagram } from "./Instagram";

export const Icons = {
  AristoByteUI,
  ArrowRight,
  BashCursor,
  Bun,
  Code,
  Copy,
  Comment,
  Components,
  Disabled,
  Dot,
  Eye,
  Error,
  GalleryVertical,
  GalleryVerticalEnd,
  GradientSquare,
  Github,
  Info,
  Instagram,
  Link,
  LinkedIn,
  Logo,
  Npm,
  OpenedBook,
  Package,
  Palette,
  PaperCode,
  Play,
  Pnpm,
  Heart,
  Resize,
  Share,
  Star,
  Stars,
  Storybook,
  Success,
  User,
  UserGroup,
  Warning,
  Yarn,
};
export { type IconPropsType } from "./type";
